const enum STATUS_ISN {
  TOBEAGREED = 223369,
  AGREED = 223370,
}

export const checkDisabledField = (statusIsn: number) => {
  return statusIsn === STATUS_ISN.AGREED || statusIsn === STATUS_ISN.TOBEAGREED;
};